import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=18e13b97&scoped=true&"
import script from "./Currencies.vue?vue&type=script&lang=ts&"
export * from "./Currencies.vue?vue&type=script&lang=ts&"
import style0 from "./Currencies.vue?vue&type=style&index=0&id=18e13b97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e13b97",
  null
  
)

export default component.exports